"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.opacity95 = exports.opacity90 = exports.opacity85 = exports.opacity80 = exports.opacity70 = exports.opacity60 = exports.opacity50 = exports.opacity5 = exports.opacity40 = exports.opacity30 = exports.opacity20 = exports.opacity15 = exports.opacity100 = exports.opacity10 = exports.opacity0 = void 0;
const opacity100 = exports.opacity100 = '100%';
const opacity95 = exports.opacity95 = '95%';
const opacity90 = exports.opacity90 = '90%';
const opacity85 = exports.opacity85 = '85%';
const opacity80 = exports.opacity80 = '80%';
const opacity70 = exports.opacity70 = '70%';
const opacity60 = exports.opacity60 = '60%';
const opacity50 = exports.opacity50 = '50%';
const opacity40 = exports.opacity40 = '40%';
const opacity30 = exports.opacity30 = '30%';
const opacity20 = exports.opacity20 = '20%';
const opacity15 = exports.opacity15 = '15%';
const opacity10 = exports.opacity10 = '10%';
const opacity5 = exports.opacity5 = '5%';
const opacity0 = exports.opacity0 = '0%';